import { assert } from '@ember/debug';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type FetchService from '@triptyk/ember-utils/services/fetch';
import type FastbootService from 'ember-cli-fastboot';
import { dropTask } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import config from 'frontend/config/environment';

export interface BaseMenuFetchComponentArgs {
  idMenu: number;
}

export interface MenuItem {
  name: string;
  url: string;
  children?: MenuItem[];
}

export default class BaseMenuFetchComponent extends Component<BaseMenuFetchComponentArgs> {
  @service declare fetch: FetchService;
  @service declare fastboot: FastbootService;
  @tracked declare menu: MenuItem[];
  constructor(owner: unknown, args: BaseMenuFetchComponentArgs) {
    super(owner, args);

    assert('@idMenu is required', args.idMenu !== undefined);
    if (this.fastboot.isFastBoot) {
      this.fastboot.deferRendering(taskFor(this.loadMenu).perform());
    } else {
      taskFor(this.loadMenu).perform() as unknown as void;
    }
  }

  @dropTask *loadMenu() {
    if (config.environment === 'test') {
      this.menu = [];
      return;
    }
    const response: Response = yield this.fetch.request(
      `update_menu/${this.args.idMenu}`
    );
    this.menu = yield response.json();
  }
}
